import { Type } from '@angular/core';
import { DefaultExport } from '@angular/router';

export function withHomeDefault(): () => Promise<DefaultExport<Type<unknown>>> {
    return () => import('./home-default.component');
}
